import {
    TeaserPressOneColumnTemplate,
    TeaserPressTwoColumnsTemplate,
} from "../../partial-templates/teaser/press/teaser-press.templates";

export const NewsroomPressOneColumnTemplate = TeaserPressOneColumnTemplate;

export const NewsroomPressTwoColumnsTemplate = TeaserPressTwoColumnsTemplate;
